import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClose", "isOpen", "children", "variantProps", "dataTestId", "updatedWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Text, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { Dismiss } from '../../../../assets/icons';
import Icon from '../../../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DataModal(_ref) {
  var _variantProps$header;
  var onClose = _ref.onClose,
    isOpen = _ref.isOpen,
    children = _ref.children,
    variantProps = _ref.variantProps,
    dataTestId = _ref.dataTestId,
    updatedWidth = _ref.updatedWidth,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var prefix = dataTestId ? "".concat(dataTestId, "-") : '';
  var width = _objectSpread({
    mobile: 'full'
  }, updatedWidth);
  var height = _objectSpread({
    mobile: 'full'
  }, variantProps === null || variantProps === void 0 ? void 0 : variantProps.modalHeight);
  var _ref2 = variantProps !== null && variantProps !== void 0 ? variantProps : {},
    _ref2$showDelimiter = _ref2.showDelimiter,
    showDelimiter = _ref2$showDelimiter === void 0 ? true : _ref2$showDelimiter;
  return _jsxs(Modal, _objectSpread(_objectSpread({
    isOpen: isOpen,
    "data-testid": "".concat(prefix, "ChakraModal"),
    preserveScrollBarGap: true,
    isCentered: true,
    closeOnOverlayClick: false,
    scrollBehavior: "inside",
    onClose: onClose,
    finalFocusRef: variantProps === null || variantProps === void 0 ? void 0 : variantProps.finalFocusRef,
    size: "md"
  }, otherProps), {}, {
    children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, _objectSpread(_objectSpread({
      "data-testid": "".concat(prefix, "ModalContent")
    }, modalContentStyle), {}, {
      width: width,
      height: height,
      children: [_jsxs(ModalHeader, _objectSpread(_objectSpread({
        "data-testid": "".concat(prefix, "ModalHeader")
      }, modalHeaderStyle), {}, {
        children: [(_variantProps$header = variantProps === null || variantProps === void 0 ? void 0 : variantProps.header) !== null && _variantProps$header !== void 0 ? _variantProps$header : (variantProps === null || variantProps === void 0 ? void 0 : variantProps.title) && _jsx(Text, _objectSpread(_objectSpread(_objectSpread({}, headerTitleStyle), {}, {
          "data-testid": "".concat(prefix, "ModalTitle")
        }, variantProps === null || variantProps === void 0 ? void 0 : variantProps.externalTitleStying), {}, {
          children: variantProps.title
        })), _jsx(ModalCloseButton, _objectSpread(_objectSpread({
          "data-testid": "".concat(prefix, "ModalCloseIcon")
        }, modalCloseButtonStyle), {}, {
          children: _jsx(Icon, {
            svg: _jsx(Dismiss, {
              transform: "scale(1.1)"
            })
          })
        }))]
      })), showDelimiter && _jsx(Box, _objectSpread({}, delimiterModalStyle)), _jsx(ModalBody, _objectSpread(_objectSpread({
        "data-testid": "".concat(prefix, "ModalBody")
      }, modalBodyStyle), {}, {
        children: children
      })), (variantProps === null || variantProps === void 0 ? void 0 : variantProps.footer) && _jsx(ModalFooter, _objectSpread(_objectSpread(_objectSpread({
        "data-testid": "".concat(prefix, "ModalFooter")
      }, modalFooterStyle), variantProps === null || variantProps === void 0 ? void 0 : variantProps.externalFooterStyling), {}, {
        children: variantProps === null || variantProps === void 0 ? void 0 : variantProps.footer
      }))]
    }))]
  }));
}
var modalContentStyle = {
  maxW: {
    mobile: 'full',
    lg: 'calc(100vw - var(--chakra-space-12))'
  },
  maxH: {
    mobile: 'full',
    lg: 'calc(100vh - var(--chakra-space-12))'
  },
  overflow: 'auto',
  borderRadius: {
    mobile: '0',
    lg: '0.875rem'
  },
  boxShadow: '0 0.125rem 0.75rem var(--chakra-colors-darkGrey2)',
  p: 0
};
var modalHeaderStyle = {
  minH: 'var(--chakra-space-xxl)',
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  alignItems: 'center',
  margin: 0,
  py: 'var(--chakra-space-5)',
  px: {
    mobile: 'md',
    sm: 'lg'
  },
  gap: 'var(--chakra-space-6)'
};
var delimiterModalStyle = {
  h: '0.063rem',
  bgColor: 'lightGrey4'
};
var headerTitleStyle = {
  color: 'darkGrey1',
  justify: 'center',
  justifyContent: 'flex-start',
  fontSize: 'lg',
  lineHeight: '3',
  fontFamily: 'header',
  padding: 0,
  margin: 0
};
var modalBodyStyle = {
  overflow: 'auto',
  p: 0
};
var modalCloseButtonStyle = {
  h: 'var(--chakra-space-xl)',
  w: 'var(--chakra-space-xl)',
  position: 'static',
  alignSelf: 'center',
  fontSize: 'xs',
  lineHeight: '3',
  fontWeight: '400',
  color: 'darkGrey2',
  _focus: {
    boxShadow: 'none'
  },
  _hover: {
    bgColor: 'transparent'
  },
  _active: {
    bgColor: 'transparent'
  }
};
var modalFooterStyle = {
  justifyContent: 'flex-start',
  overflow: 'auto'
};